import React, { createContext, useContext, useState, useCallback } from 'react';
import PlanSelectionPopup from './PlanSelectionPopup';

const PlanSelectionContext = createContext(null);

export const PlanSelectionProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [callback, setCallback] = useState();

  const open = useCallback(cb => {
    setCallback(() => cb);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => setIsOpen(false), []);

  const handleSelect = plan => {
    if (callback) callback(plan);
    close();
  };

  return (
    <PlanSelectionContext.Provider value={{ open, close }}>
      {children}
      <PlanSelectionPopup show={isOpen} onClose={close} onPlanSelect={handleSelect} />
    </PlanSelectionContext.Provider>
  );
};

export const usePlanSelection = () => {
  const ctx = useContext(PlanSelectionContext);
  if (!ctx) throw new Error('usePlanSelection must be used inside PlanSelectionProvider');
  return ctx;
};
